import { fetchAuthSession } from '@aws-amplify/auth';

import { BACKEND_AGENTS_API } from '../env';

// La ruta /chart-config vive en whisperbi-agent-management-strands
// (billing-admin/app.py), sobre la misma AgentsAdminApi que ya usa
// AgentService.js -- no es whisperbi-credits-engine. Solo autenticación
// Cognito (Bearer ID token), sin x-api-key, mismo criterio que las demás
// rutas de administración de esta API.
const API_BASE = BACKEND_AGENTS_API;

const defaultHeaders = {
  Accept: 'application/json'
};

async function getAuthHeader() {
  try {
    const tokens = (await fetchAuthSession()).tokens;
    const idToken = tokens?.idToken?.toString();
    if (idToken) {
      return { Authorization: `Bearer ${idToken}` };
    }
  } catch (error) {
    console.error('❌ ChartConfigService.getAuthHeader: unable to fetch session', error);
  }
  return {};
}

// Exportada para las otras rutas de configuración de esta API
// (AnalysisConfigService.js).
export async function request(path, init = {}) {
  const authHeader = await getAuthHeader();

  const headers = {
    ...defaultHeaders,
    ...(init.body ? { 'Content-Type': 'application/json' } : {}),
    ...(init.headers || {}),
    ...authHeader
  };

  const url = path.startsWith('http') ? path : `${API_BASE}${path}`;

  let response;
  try {
    response = await fetch(url, { ...init, headers, mode: 'cors', cache: 'no-cache' });
  } catch (networkError) {
    throw new Error(`No se pudo contactar la API de administración (${url}). ${networkError.message}`);
  }

  const requestId =
    response.headers.get('x-amzn-requestid') ||
    response.headers.get('x-amz-apigw-id') ||
    response.headers.get('x-request-id') ||
    'n/a';

  if (!response.ok) {
    const errorBody = await response.text().catch(() => '');
    let technicalMessage = errorBody || `HTTP ${response.status}`;
    try {
      const parsed = JSON.parse(errorBody);
      technicalMessage = parsed.error || parsed.message || technicalMessage;
    } catch {
      // Response body wasn't JSON — keep the raw text.
    }

    const error = new Error(technicalMessage);
    error.technicalMessage = `HTTP ${response.status} (reqId=${requestId}): ${technicalMessage}`;
    error.status = response.status;
    error.requestId = requestId;
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  const text = await response.text();
  if (!text) {
    return null;
  }
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

const ChartConfigService = {
  async getConfig() {
    return request('/chart-config', { method: 'GET' });
  },
  async upsertConfig(payload) {
    return request('/chart-config', { method: 'PUT', body: JSON.stringify(payload) });
  }
};

export default ChartConfigService;
